import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dba79d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-appoitment-page grid-container" }
const _hoisted_2 = { class: "form-grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Confirmed", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Cancelled", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Applicant Followed Up", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Owner Followed Up", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Follow Up Due Date", -1))
const _hoisted_8 = { class: "center-toggle" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, null, -1))
const _hoisted_10 = { class: "edit-appoitment-page" }
const _hoisted_11 = ["onMouseover"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onMouseover"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "custom-feedback-cells" }
const _hoisted_16 = { class: "edit-appoitment-page" }
const _hoisted_17 = { class: "more-details-page" }
const _hoisted_18 = { class: "more-details-group recurrance-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-title" }, "Repeat", -1))
const _hoisted_20 = { class: "date-toggle-pair" }
const _hoisted_21 = { class: "more-details-group system-information-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-title" }, "System Information", -1))

import ModalBase from "@/components/ui/modals/modal-base.vue";
import { computed, watch, inject, ref, onMounted, onUnmounted } from "vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { EditAppointment } from "@/types/diary/EditAppointment";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import { AppointmentsValidation } from "acquaint-api/validation/AppointmentsValidation";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import AttendeePropertyList from "@/components/ui/diary/attendee-property-list.vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { AppoinmentContactList } from "@/types/diary/AppointmentContactList";
import { AppointmentPropertyList } from "@/types/diary/AppointmentPropertyList";
import FindPropertyModal from "@/components/find/properties/find-property-modal.vue";
import FindContactModal from "@/components/find/contacts/find-contact-modal.vue";
import SelectUserModal from "@/components/ui/diary/select-user-modal.vue";
import { PropertyFindResult } from "@/types/find/properties/PropertyFindResult";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { DoubleBooking } from "@/types/diary/DoubleBooking";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { AppointmentType } from "@/types/diary/AppointmentType";
import moment from "moment";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { ValidatedEvent } from "devextreme/ui/validator";
import { TimeStamps } from "@/utils/TimeStamp";
import DateToggle from "@/components/ui/toggles/date-toggle.vue";
import { validateAttendees } from "@/utils/appointments/AppointmentValidator";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { AppointmentFeedback } from "@/types/diary/AppointmentFeedback";
import { DisplayedAppointmentFeedback } from "@/types/diary/DisplayedAppointmentFeedback";
import { PropertyDetailsSentResponse } from "@/enums/PropertyDetailsSentResponse";
import EditFeedbackModal from "@/components/ui/diary/edit-feedback-modal.vue";
import ContactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import PropertyPeekModal from "@/components/properties/property-peek-modal.vue";
import AppointmentConfirmationModal from "@/components/ui/diary/appointment-confirmation-modal.vue";
import AcquaintInfoBox from "../inputs/acquaint-info-box.vue";
import { DxButton } from "devextreme-vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { formatDate } from "bright-logic-core/src/format";
import { ReminderIntervals } from "@/enums/appointments/ReminderIntervals";
import ContactModal from "@/components/contacts/record/contact-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-appointment-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The ID of the appointment related to the current operation.
   * @type {number}
   * @default 0
   */
  appointmentId: {
    type: Number,
    required: true,
  },
  /**
   * Determines whether the edit fields should be locked.
   * @type {boolean}
   * @default false
   */
  lockEditFields: {
    type: Boolean,
    default: false,
  },
  notificationAppointment: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the modal is closed.
   * @param {boolean} isFromModalClose - Indicates whether the event was triggered by closing the modal or from another action.
   * @param {number | undefined} appointmentId - The ID of the associated appointment, if available.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

onMounted(async () => {
  currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
  window.addEventListener("resize", updateScreenSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
});

const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const acquaintApi = inject("AcquaintApiClient") as AcquaintApiClient;
const appointment = ref<EditAppointment>();
const originalAppointment = ref<EditAppointment>();
const propertyList = ref<AppointmentPropertyList[]>([]);
const attendeesList = ref<AppoinmentContactList[]>([]);
const showFindPropertyModal = ref(false);
const showFindContactModal = ref(false);
const showSelectUserModal = ref(false);
const contactListKey = ref(0);
const propertyListKey = ref(0);
const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const selectedTypeDetails = ref<AppointmentType>();
const systemConfigStore = useSystemConfigurationStore();
const defaultAppointmentDuration = ref(0);
const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const selectedTabPanel = ref(0);
const preventStartDateWatch = ref(false);
const preventEndDateWatch = ref(false);
const loadingContent = ref(false);
const focusNotesField = ref(false);
const feedbackList = ref<AppointmentFeedback[]>([]);
const displayedFeedbackList = ref<DisplayedAppointmentFeedback[]>([]);
const feedbackGridLoading = ref(false);
const hoverFeedbackId = ref(-1);
const displayEditFeebackModal = ref(false);
const feedbackContactId = ref(0);
const feedbackPropertyId = ref(0);
const displayContactPeekModal = ref(false);
const displayPropertyPeekModal = ref(false);
const peekContactId = ref(0);
const contactName = ref("");
const propertyPeekTitle = ref("");
const peekPropertyId = ref(0);
const isMobile = ref<boolean>(window.innerWidth <= 768);
const displayAppointmentConfirmationModal = ref(false);
const createRecurrenceEndDate = ref(false);
const displayNewContactModal = ref(false);

const updateScreenSize = () => {
  isMobile.value = window.innerWidth <= 768;
};

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    saving.value = false;
    appointment.value = undefined;

    fetchAndDisplayData(props.appointmentId);
  },
);

const fetchAndDisplayData = async (id: number) => {
  selectedTabPanel.value = 0;
  propertyList.value = [];
  attendeesList.value = [];
  defaultAppointmentDuration.value = 0;
  peekContactId.value = 0;
  contactName.value = "";
  propertyPeekTitle.value = "";
  peekPropertyId.value = 0;
  appointment.value = undefined;

  await fetchAppointment(id);
  /* If we can't get the appointment, it's most likely been deleted on another device
   * In this instance close the modal and force the parent to refresh */
  if (!originalAppointment.value) {
    showModal.value = false;
    emit("modalClosed", true, id);
    return;
  }
  appointment.value = JSON.parse(JSON.stringify(originalAppointment.value));

  await fetchTypeDetails(originalAppointment.value.typeId);
  defaultAppointmentDuration.value = Number(
    await systemConfigStore.getSystemConfigurationValue(
      SystemConfiguration.AppointmentDefaultDuration,
    ),
  );

  updateFeedbackList();
  // This is set to true to display the recurrence end date field, matching desktop acquaint.
  if (appointment.value && appointment.value.recurrenceEndDate != "") {
    createRecurrenceEndDate.value = true;
  }
  prePopulateProperties();
};

const prePopulateProperties = async () => {
  if (!appointment.value) {
    propertyList.value = [];
    attendeesList.value = [];
    return;
  }

  appointment.value.properties.forEach((property) =>
    propertyList.value.push({
      id: property.propertyId,
      address: property.address,
      confirmed: property.confirmed,
    }),
  );
  appointment.value.attendees.forEach((attendee) =>
    attendeesList.value.push({
      id: attendee.contactId,
      name: attendee.name,
      confirmed: attendee.confirmed,
    }),
  );
};

const fetchAppointment = async (id: number) => {
  loadingContent.value = true;
  try {
    originalAppointment.value = await acquaintApi.httpGet(
      `app/appointments/${id}`,
    );
  } catch (err) {
    await standardInfoAlert(getErrorMessage(err));
    originalAppointment.value = undefined;
  }
  loadingContent.value = false;
};

const onCancelClick = async () => {
  if (!appointment.value) {
    return;
  }
  appointment.value.reminderInterval = ReminderIntervals.None;
  await submitAppointmentData(appointment.value);
  showModal.value = false;
};

const onSaveClick = async (
  e: any,
  isFromConfirmation: boolean = false,
): Promise<boolean> => {
  if (!appointment.value) {
    return false;
  }

  const validation: ValidatedEvent = e.validationGroup.validate();

  // Stop execution if validation fails
  if (!validation.isValid || !(await validateAttendeesStep())) {
    return false;
  }

  saving.value = true;

  const success = await submitAppointmentData(appointment.value);

  if (success) {
    displayCancelConfirmationModal.value = false;
    if (!isFromConfirmation) {
      emit("modalClosed", true, appointment.value.id);
    }
    showModal.value = false;
  } else {
    saving.value = false;
  }

  return success;
};

const onSnoozeClick = (e: any) => {
  if (!appointment.value) {
    return;
  }
  appointment.value.reminderInterval = ReminderIntervals.FiveMinutes;
  onSaveClick(e);
};

const submitAppointmentData = async (dataToSubmit: EditAppointment) => {
  try {
    await acquaintApi.httpPutVoid(
      `app/appointments/${dataToSubmit.id}`,
      dataToSubmit,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

// When a user chooses a type of attendee to add from the dropdown on the 2nd page, this is triggered
const onMenuItemClick = (key: string) => {
  switch (key) {
    case "contact":
      showFindContactModal.value = true;
      break;
    case "me":
      currentUserOptionClicked();
      break;
    case "user":
      showSelectUserModal.value = true;
      break;
  }
};

const propertySelected = (property: PropertyFindResult) => {
  if (!property) {
    return;
  }

  // If the property is already in the list, we can't add it a second time
  const propertyAlreadyInList: undefined | PropertyFindResult =
    propertyList.value.find((prop) => {
      return prop.id == property.id;
    });

  if (propertyAlreadyInList) {
    return;
  }

  propertyList.value.push({
    id: property.id,
    address: property.address,
    confirmed: true,
  });

  refreshFeedbackList();

  propertyListKey.value++;
};

// If the contact is already in the list, we can't add it a second time
const checkAttendeeIsInList = (attendeeId: number) => {
  const contactAlreadyInList: undefined | AppoinmentContactList =
    attendeesList.value.find((contact) => {
      return contact.id == attendeeId;
    });

  return contactAlreadyInList;
};

const contactSelected = async (contact: ContactFindResult) => {
  if (!contact) {
    return;
  }

  await addContactAsAttendee(contact.id, contact.name);
};

const onPrimaryContactSelected = async (id: number, name: string) => {
  if (!id) {
    return;
  }

  await addContactAsAttendee(id, name);
};

const addContactAsAttendee = async (id: number, name: string) => {
  if (checkAttendeeIsInList(id)) {
    return;
  }

  if (!(await checkForDoubleBooking(id))) {
    return;
  }

  attendeesList.value.push({ id: id, name: name, confirmed: true });

  refreshFeedbackList();

  contactListKey.value++;
};

// When the contact or property list, the feedback needs to be updated.
const refreshFeedbackList = async () => {
  if (!originalAppointment.value) {
    return;
  }

  let dataToSubmit: EditAppointment = JSON.parse(
    JSON.stringify(originalAppointment.value),
  );

  propertyList.value.forEach((property) =>
    dataToSubmit.properties.push({
      propertyId: property.id,
      address: property.address,
      confirmed: property.confirmed,
    }),
  );
  attendeesList.value.forEach((attendee) =>
    dataToSubmit.attendees.push({
      contactId: attendee.id,
      name: attendee.name,
      confirmed: attendee.confirmed,
    }),
  );

  await submitAppointmentData(dataToSubmit);
  updateFeedbackList();
};

const userSelected = async (selectedUserId: number, name: string) => {
  if (!selectedUserId) {
    return;
  }

  if (checkAttendeeIsInList(selectedUserId)) {
    return;
  }

  if (!(await checkForDoubleBooking(selectedUserId))) {
    return;
  }

  attendeesList.value.push({ id: selectedUserId, name: name, confirmed: true });

  contactListKey.value++;
};

/*** Sets the apppointment as confirmed, if all attendees and properties have been confirmed */
const syncConfirmedState = () => {
  if (!appointment.value) {
    return;
  }

  if (
    !attendeesList.value.every((item) => item.confirmed) ||
    !propertyList.value.every((item) => item.confirmed)
  ) {
    appointment.value.confirmedDate = "";
    return;
  }

  // Only set confirmed date if it's not already set. This prevents the original confirmed date being overwritten
  if (!appointment.value.confirmedDate) {
    appointment.value.confirmedDate = moment().format("yyyy-MM-DDTHH:mm");
  }
};

watch(
  () => attendeesList.value,
  () => {
    if (!appointment.value) {
      return;
    }

    syncConfirmedState();

    // We must reset this so that the same record isn't submitted more than once in the API call
    appointment.value.attendees = [];
    attendeesList.value.forEach((attendee) =>
      appointment.value?.attendees.push({
        contactId: attendee.id,
        name: attendee.name,
        confirmed: attendee.confirmed,
      }),
    );
  },
  { deep: true },
);

watch(
  () => propertyList.value,
  () => {
    if (!appointment.value) {
      return;
    }

    syncConfirmedState();

    // We must reset this so that the same record isn't submitted more than once in the API call
    appointment.value.properties = [];
    propertyList.value.forEach((property) =>
      appointment.value?.properties.push({
        propertyId: property.id,
        address: property.address,
        confirmed: property.confirmed,
      }),
    );
  },
  { deep: true },
);

const currentUserOptionClicked = async () => {
  if (!currentUserDetails.value) {
    return;
  }

  if (checkAttendeeIsInList(currentUserDetails.value.id)) {
    return;
  }

  if (!(await checkForDoubleBooking(currentUserDetails.value.id))) {
    return;
  }

  // To prevent the user being booked twice for the same appoinment, we must check if they are already in the list of attendees

  let currentUserInList = appointment.value?.attendees.find((attendee) => {
    return attendee.contactId == currentUserDetails.value?.id;
  });

  if (currentUserInList) {
    return;
  }

  attendeesList.value.push({
    id: currentUserDetails.value.id,
    name: currentUserDetails.value.name,
    confirmed: true,
  });
  contactListKey.value++;
};

const deleteAttendee = (attendeeId: number) => {
  attendeesList.value = attendeesList.value.filter((attendee) => {
    return attendee.id != attendeeId;
  });
  refreshFeedbackList();
};

const deleteProperty = (propertyId: number) => {
  propertyList.value = propertyList.value.filter((property) => {
    return property.id != propertyId;
  });
  refreshFeedbackList();
};

const checkForDoubleBooking = async (contactId: number) => {
  const doubleBookingResponse: DoubleBooking =
    await callDoubleBookingApi(contactId);

  if (doubleBookingResponse.available) {
    return true;
  }

  const doubleBookingAlert = standardInfoAlert(
    `Sorry, this Contact cannot be added to this appointment as they are\nalready attending another at this date/time:\n${doubleBookingResponse.info}`,
  );

  await doubleBookingAlert;

  return false;
};

const callDoubleBookingApi = async (
  contactId: number,
): Promise<DoubleBooking> => {
  try {
    return await apiNextClient.httpPost("appointments/doublebooking/check", {
      appointmentId: appointment.value?.id,
      startDate: appointment.value?.startDate,
      endDate: appointment.value?.endDate,
      appointmentTypeId: appointment.value?.typeId,
      contactId: contactId,
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return { available: false, info: "" };
  }
};

const createNewProperty = () => {
  showFindPropertyModal.value = true;
};

// When a type is selected, we need to ensure the end date is set to the start date plus the
// appointment type's default length
watch(
  () => appointment.value?.typeId,
  async (value, prevValue) => {
    // The end date of the original data object is set if a type has been stored in a cookie, so there is no point calling the appointment
    // type twice
    if (!appointment.value || !prevValue) {
      return;
    }

    if (appointment.value.typeId > 0) {
      await fetchTypeDetails(appointment.value?.typeId);
      setEndDate();
    }
  },
);

// When the start date is changed, we need to ensure the end date is set to the start date plus the
// appointment type's default length

// If the start or end date is changed, we must check if the attendees have any conflicting appointments
watch(
  () => appointment.value?.startDate,
  async (value, oldValue) => {
    if (preventStartDateWatch.value) {
      preventStartDateWatch.value = false;
      return;
    }

    if (!appointment.value || !oldValue) {
      return;
    }

    if (appointment.value && appointment.value.typeId > 0) {
      setEndDate();
    }

    let numberOfBookedAttendees = 0;

    numberOfBookedAttendees = await checkForBlockedAttendees();

    // If any of the attendees are at risk of being double booked, we must reset the date
    // and prevent this triggering a watch further times and an endless loop of the attendees
    // being checked
    if (numberOfBookedAttendees > 0) {
      preventStartDateWatch.value = true;
      appointment.value.startDate = oldValue;
    }
  },
);

// We go through the attendees list and check each one to see if it could be double booked
// We use a for loop rather than the for each method to ensure the double booking alert
// is displayed for each of the attendees at risk
const checkForBlockedAttendees = async () => {
  let numberOfBookedAttendees = 0;

  for (let i = 0; i < attendeesList.value.length; i++) {
    if (await checkForDoubleBooking(attendeesList.value[i].id)) {
      return numberOfBookedAttendees;
    }

    numberOfBookedAttendees++;
  }

  return numberOfBookedAttendees;
};

watch(
  () => appointment.value?.endDate,
  async (value, oldValue) => {
    if (preventEndDateWatch.value) {
      preventEndDateWatch.value = false;
      return;
    }

    if (!appointment.value || !oldValue) {
      return;
    }

    let numberOfBookedAttendees = 0;

    numberOfBookedAttendees = await checkForBlockedAttendees();

    // If any of the attendees are at risk of being double booked, we must reset the date
    // and prevent this triggering a watch further times and an endless loop of the attendees
    // being checked
    if (numberOfBookedAttendees > 0) {
      preventEndDateWatch.value = true;
      appointment.value.endDate = oldValue;
    }
  },
);

const fetchTypeDetails = async (typeId: number) => {
  try {
    selectedTypeDetails.value = await acquaintApi.httpGet(
      `database/appointmenttypes/${typeId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    selectedTypeDetails.value = undefined;
  }
};

const setEndDate = async () => {
  if (selectedTypeDetails.value && appointment.value) {
    appointment.value.endDate = calculateEndDateWithDefaultDuration(
      appointment.value.startDate,
    );
  }
};

const calculateEndDateWithDefaultDuration = (startDate: string) => {
  let date = new Date(startDate);
  let defaultDuration = selectedTypeDetails.value?.duration
    ? selectedTypeDetails.value.duration
    : defaultAppointmentDuration.value;

  // For backwards compatibility with Desktop Acquaint, we must minus a minute from the default duration
  defaultDuration--;

  date.setMinutes(date.getMinutes() + defaultDuration);
  return moment(date).format("YYYY-MM-DDTHH:mm");
};

watch(
  () => appointment.value,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(appointment.value) !=
      JSON.stringify(originalAppointment.value);
  },
  { deep: true },
);

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false, appointment.value?.id);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const addTimeStamp = async () => {
  if (!appointment.value) {
    return;
  }

  appointment.value.notes = await TimeStamps(appointment.value.notes);
  focusNotesField.value = true;

  setTimeout(() => {
    focusNotesField.value = false;
  }, 50);
};

const confirmToggleValueUpdated = (value: boolean) => {
  attendeesList.value.forEach((attendee) => {
    attendee.confirmed = value;
  });

  propertyList.value.forEach((property) => {
    property.confirmed = value;
  });
};

const validateAttendeesStep = async () => {
  if (!selectedTypeDetails.value || !appointment.value) {
    return true;
  }

  return await validateAttendees(
    selectedTypeDetails.value,
    appointment.value.attendees.length,
    appointment.value.properties.length,
  );
};

// Feedback list
const updateFeedbackList = async () => {
  feedbackGridLoading.value = true;
  displayedFeedbackList.value = [];

  await fetchFeedbackList();

  // We can't use the api response as each row needs a unique id so that users can interact with
  // the rows individually such as double clicking them to make the edit modal appear.
  if (feedbackList.value.length > 0) {
    for (let i = 0; i < feedbackList.value.length; i++) {
      displayedFeedbackList.value.push({
        id: i,
        contactId: feedbackList.value[i].contactId,
        applicantName: feedbackList.value[i].applicantName,
        propertyId: feedbackList.value[i].propertyId,
        propertyName: feedbackList.value[i].propertyName,
        propertyAddress: feedbackList.value[i].propertyAddress,
        response: feedbackList.value[i].response,
        notes: feedbackList.value[i].notes,
        locationRating: feedbackList.value[i].locationRating,
        conditionRating: feedbackList.value[i].conditionRating,
        priceRating: feedbackList.value[i].priceRating,
      });
    }
  }

  feedbackGridLoading.value = false;
};

const fetchFeedbackList = async () => {
  try {
    feedbackList.value = await apiNextClient.httpGet(
      `Feedback/${appointment.value?.id}`,
    );
  } catch (err) {
    displayErrorMessage("The appointment's feedback could not be fetched.");
    feedbackList.value = [];
  }
};

const feedbackModalClosed = (dataUpdated: true) => {
  if (dataUpdated) {
    updateFeedbackList();
  }
};

const feedbackItemDoubleClicked = (e: AppointmentFeedback) => {
  feedbackContactId.value = e.contactId;
  feedbackPropertyId.value = e.propertyId;
  setTimeout(() => {
    displayEditFeebackModal.value = true;
  }, 100);
};

const showContactPeek = (contactId: number, name: string) => {
  peekContactId.value = contactId;
  contactName.value = name;
  displayContactPeekModal.value = true;
};

const showPropertyPeek = (propertyId: number, propertyAddress: string) => {
  peekPropertyId.value = propertyId;
  propertyPeekTitle.value = `${propertyAddress} (${propertyId})`;
  displayPropertyPeekModal.value = true;
};

const mouseOver = (correspondenceId: number) => {
  hoverFeedbackId.value = correspondenceId;
};

const mouseLeave = () => {
  hoverFeedbackId.value = -1;
};

const fetchResponse = (responseId: number) => {
  switch (responseId) {
    case PropertyDetailsSentResponse.Interested:
      return "Interested";
    case PropertyDetailsSentResponse.NotInterested:
      return "Not Interested";
    case PropertyDetailsSentResponse.Undecided:
      return "Undecided";
  }
};
const onSaveSendConfirmation = async (e: any) => {
  if (await onSaveClick(e, true)) {
    displayAppointmentConfirmationModal.value = true;
  }
};

const switchToOriginalAppointment = async () => {
  selectedTabPanel.value = 0;
  await unLockAppointment(props.appointmentId);
  if (
    !(await lockAppointments(appointment.value?.recurrenceAppointmentId ?? 0))
  ) {
    return;
  }
  fetchAndDisplayData(appointment.value?.recurrenceAppointmentId ?? 0);
};

const lockAppointments = async (id: number) => {
  try {
    await acquaintApi.httpPostVoid(`database/appointments/${id}/lock`, {
      lock: true,
      extraInfo: "",
    });
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const unLockAppointment = async (id: number) => {
  try {
    acquaintApi.httpPostVoid(`database/appointments/${id}/lock`, {
      lock: false,
      extraInfo: "",
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// When the id is greater than 0 (truthy), the fields should be disabled because users should only be allowed to edit the details of the original appointment
const disableRecurranceFields = computed(() => {
  return !!appointment.value?.recurrenceAppointmentId;
});

const formatedFollowUpDueDate = computed(() => {
  return appointment.value?.followUpDueDate
    ? formatDate(appointment.value?.followUpDueDate, true)
    : "";
});

const formatedLastUpdatedDate = computed(() => {
  return appointment.value?.lastUpdatedDate
    ? formatDate(appointment.value?.lastUpdatedDate, true)
    : "";
});

const formattedAddedDate = computed(() => {
  return appointment.value?.addedDate
    ? formatDate(appointment.value?.addedDate, true)
    : "";
});

watch(
  () => createRecurrenceEndDate.value,
  (value) => {
    if (!appointment.value) {
      return;
    }

    if (!value) {
      appointment.value.recurrenceEndDate = "";
    }

    // If there is no recurrence date returned by the endpoint, we will set it to the provided start date
    if (appointment.value.recurrenceEndDate == "") {
      appointment.value.recurrenceEndDate = moment().format("YYYY-MM-DD");
    }
  },
);

const recurrenceMinEndDate = computed(() => {
  if (!appointment.value) {
    return new Date("1900-01-01");
  }

  return new Date(appointment.value.startDate);
});
const onAppointmentConfirmationModalClosed = () => {
  emit("modalClosed", true, appointment.value?.id);
};

const newContactCreated = async (
  contactId: number,
  addPropertyAfterClose: boolean,
  name: string,
) => {
  await addContactAsAttendee(contactId, name);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showModal).value = $event)),
      title: "Appointment",
      showCloseButton: true,
      height: "775px",
      maxHeight: "90vh",
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      onModalClosed: modalClosed,
      onCancelPromptDenied: cancelPromptDenied,
      loadingContent: loadingContent.value,
      onXButtonClicked: onCancelClick
    }, {
      content: _withCtx(() => [
        (appointment.value)
          ? (_openBlock(), _createBlock(_unref(DxTabPanel), {
              key: 0,
              "scroll-by-content": true,
              "show-nav-buttons": true,
              "swipe-enabled": false,
              selectedIndex: selectedTabPanel.value,
              "onUpdate:selectedIndex": _cache[19] || (_cache[19] = ($event: any) => ((selectedTabPanel).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxItem), { title: 'General' }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(LookupSingleSelect, {
                          label: "Type",
                          modelValue: appointment.value.typeId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appointment.value.typeId) = $event)),
                          allowZeroValue: false,
                          requiredInput: true,
                          "read-only": props.lockEditFields,
                          lookupSource: _unref(LookupTableSource).AppointmentTypes,
                          "validation-group": "edit-appointment-modal"
                        }, null, 8, ["modelValue", "read-only", "lookupSource"]),
                        _createVNode(SystemCodeSingleSelect, {
                          label: "Reminder Interval",
                          modelValue: appointment.value.reminderInterval,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appointment.value.reminderInterval) = $event)),
                          "code-type": _unref(CodeType).AppointmentReminderInterval,
                          "read-only": props.lockEditFields
                        }, null, 8, ["modelValue", "code-type", "read-only"]),
                        _createVNode(AcquaintDateBox, {
                          label: "Start Date",
                          modelValue: appointment.value.startDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appointment.value.startDate) = $event)),
                          includeTime: true,
                          fieldValidation: _unref(AppointmentsValidation).StartDate,
                          "read-only": props.lockEditFields,
                          "validation-group": "edit-appointment-modal"
                        }, null, 8, ["modelValue", "fieldValidation", "read-only"]),
                        _createVNode(AcquaintDateBox, {
                          label: "End Date",
                          modelValue: appointment.value.endDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((appointment.value.endDate) = $event)),
                          includeTime: true,
                          "read-only": props.lockEditFields,
                          fieldValidation: _unref(AppointmentsValidation).EndDate,
                          minDate: new Date(appointment.value.startDate),
                          "validation-group": "edit-appointment-modal"
                        }, null, 8, ["modelValue", "read-only", "fieldValidation", "minDate"]),
                        _createElementVNode("div", null, [
                          _hoisted_3,
                          _createVNode(DateToggle, {
                            modelValue: appointment.value.confirmedDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((appointment.value.confirmedDate) = $event)),
                            "include-time": true,
                            fieldValidation: _unref(AppointmentsValidation).ConfirmedDate,
                            "read-only": props.lockEditFields,
                            onToggleValueUpdated: confirmToggleValueUpdated
                          }, null, 8, ["modelValue", "fieldValidation", "read-only"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_4,
                          _createVNode(DateToggle, {
                            modelValue: appointment.value.cancelledDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((appointment.value.cancelledDate) = $event)),
                            includeTime: true,
                            fieldValidation: _unref(AppointmentsValidation).CancelledDate,
                            "read-only": props.lockEditFields
                          }, null, 8, ["modelValue", "fieldValidation", "read-only"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_5,
                          _createVNode(DateToggle, {
                            modelValue: appointment.value.applicantFollowedUpDate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((appointment.value.applicantFollowedUpDate) = $event)),
                            includeTime: true,
                            fieldValidation: _unref(AppointmentsValidation).FollowedUpDate,
                            "read-only": props.lockEditFields
                          }, null, 8, ["modelValue", "fieldValidation", "read-only"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_6,
                          _createVNode(DateToggle, {
                            modelValue: appointment.value.ownerFollowedUpDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((appointment.value.ownerFollowedUpDate) = $event)),
                            includeTime: true,
                            fieldValidation: _unref(AppointmentsValidation).FollowedUpOwnerDate,
                            "read-only": props.lockEditFields
                          }, null, 8, ["modelValue", "fieldValidation", "read-only"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_7,
                          _createVNode(DateToggle, {
                            modelValue: appointment.value.followUpDueDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((appointment.value.followUpDueDate) = $event)),
                            fieldValidation: _unref(AppointmentsValidation).FollowUpDueDate,
                            "read-only": props.lockEditFields
                          }, null, 8, ["modelValue", "fieldValidation", "read-only"])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createVNode(SwitchToggle, {
                            label: "No Show",
                            modelValue: appointment.value.noShow,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((appointment.value.noShow) = $event)),
                            readOnly: props.lockEditFields
                          }, null, 8, ["modelValue", "readOnly"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), {
                  title: isMobile.value ? 'Attendees' : 'Attendees and Properties'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_10, [
                      (_openBlock(), _createBlock(AttendeePropertyList, {
                        modelValue: attendeesList.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((attendeesList).value = $event)),
                        onItemClicked: onMenuItemClick,
                        onDeleteGridItem: deleteAttendee,
                        key: contactListKey.value,
                        attendeeListDropdownId: "edit-attendee-types-menu",
                        "read-only": props.lockEditFields
                      }, null, 8, ["modelValue", "read-only"])),
                      (_openBlock(), _createBlock(AttendeePropertyList, {
                        modelValue: propertyList.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((propertyList).value = $event)),
                        isAttendee: false,
                        onDeleteGridItem: deleteProperty,
                        key: propertyListKey.value,
                        onCreateNewProperty: createNewProperty,
                        "read-only": props.lockEditFields
                      }, null, 8, ["modelValue", "read-only"]))
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_unref(DxItem), { title: 'Feedback' }, {
                  default: _withCtx(() => [
                    _createVNode(GridBase, {
                      "data-source": displayedFeedbackList.value,
                      onRowClick: feedbackItemDoubleClicked,
                      customColumnSlots: [
              'applicantCell',
              'propertyCell',
              'responseCell',
            ],
                      loading: feedbackGridLoading.value
                    }, {
                      columns: _withCtx(() => [
                        _createVNode(_unref(DxColumn), {
                          "data-field": "applicantName",
                          caption: "Applicant",
                          "hiding-priority": 3,
                          "cell-template": "applicantCell"
                        }),
                        _createVNode(_unref(DxColumn), {
                          "data-field": "propertyAddress",
                          caption: "Property",
                          "hiding-priority": 3,
                          "cell-template": "propertyCell"
                        }),
                        _createVNode(_unref(DxColumn), {
                          "data-field": "response",
                          caption: "Feedback",
                          "hiding-priority": 2,
                          "cell-template": "responseCell"
                        }),
                        _createVNode(_unref(DxColumn), {
                          "data-field": "notes",
                          caption: "Feedback Notes",
                          "hiding-priority": 1
                        })
                      ]),
                      applicantCellData: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          onMouseover: ($event: any) => (mouseOver(data.id)),
                          onMouseleave: mouseLeave,
                          class: "custom-feedback-cells contact-property-cells"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(data.applicantName), 1),
                          (data.propertyId && data.id == hoverFeedbackId.value)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "fas fa-eye",
                                onClick: ($event: any) => (showContactPeek(data.contactId, data.applicantName))
                              }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_11)
                      ]),
                      propertyCellData: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          onMouseover: ($event: any) => (mouseOver(data.id)),
                          onMouseleave: mouseLeave,
                          class: "custom-feedback-cells contact-property-cells"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(data.propertyAddress), 1),
                          (data.propertyId && data.id == hoverFeedbackId.value)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "fas fa-eye",
                                onClick: ($event: any) => (
                    showPropertyPeek(data.propertyId, data.propertyAddress)
                  )
                              }, null, 8, _hoisted_14))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_13)
                      ]),
                      responseCellData: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString(fetchResponse(data.response)), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: 'Notes' }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_16, [
                      _createVNode(AcquaintTextArea, {
                        label: "Notes",
                        modelValue: appointment.value.notes,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((appointment.value.notes) = $event)),
                        fieldValidation: _unref(AppointmentsValidation).Notes,
                        "validation-group": "edit-appointment-modal",
                        "read-only": props.lockEditFields,
                        focusInput: focusNotesField.value
                      }, null, 8, ["modelValue", "fieldValidation", "read-only", "focusInput"]),
                      _createVNode(_unref(DxButton), {
                        text: "Date Stamp",
                        disabled: saving.value,
                        onClick: addTimeStamp
                      }, null, 8, ["disabled"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "More Details" }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(SystemCodeSingleSelect, {
                          label: "Frequency",
                          modelValue: appointment.value.recurranceFrequency,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((appointment.value.recurranceFrequency) = $event)),
                          "code-type": _unref(CodeType).AppointmentRecurrenceFrequency,
                          "read-only": disableRecurranceFields.value
                        }, null, 8, ["modelValue", "code-type", "read-only"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(SwitchToggle, {
                            label: "End Date",
                            modelValue: createRecurrenceEndDate.value,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createRecurrenceEndDate).value = $event)),
                            "read-only": disableRecurranceFields.value
                          }, null, 8, ["modelValue", "read-only"]),
                          (createRecurrenceEndDate.value)
                            ? (_openBlock(), _createBlock(AcquaintDateBox, {
                                key: 0,
                                "min-date": recurrenceMinEndDate.value,
                                modelValue: appointment.value.recurrenceEndDate,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((appointment.value.recurrenceEndDate) = $event)),
                                includeTime: false,
                                "read-only": disableRecurranceFields.value,
                                fieldValidation: _unref(AppointmentsValidation).RecurrenceEndDate,
                                width: _unref(FieldSize).Small
                              }, null, 8, ["min-date", "modelValue", "read-only", "fieldValidation", "width"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (appointment.value.recurrenceAppointmentId > 0)
                        ? (_openBlock(), _createBlock(_unref(DxButton), {
                            key: 0,
                            text: "Switch To Original Appointment",
                            onClick: switchToOriginalAppointment,
                            width: "225px"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(LookupSingleSelect, {
                          label: "Branch",
                          modelValue: appointment.value.siteId,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((appointment.value.siteId) = $event)),
                          lookupSource: _unref(LookupTableSource).Sites,
                          "read-only": props.lockEditFields
                        }, null, 8, ["modelValue", "lookupSource", "read-only"]),
                        _createVNode(LookupSingleSelect, {
                          label: "Added By",
                          modelValue: appointment.value.userId,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((appointment.value.userId) = $event)),
                          lookupSource: _unref(LookupTableSource).Users,
                          "read-only": true
                        }, null, 8, ["modelValue", "lookupSource"]),
                        _createVNode(AcquaintInfoBox, {
                          label: "Added Date/Time",
                          text: formattedAddedDate.value
                        }, null, 8, ["text"]),
                        _createVNode(LookupSingleSelect, {
                          label: "Assigned To",
                          modelValue: appointment.value.assignedUserId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((appointment.value.assignedUserId) = $event)),
                          lookupSource: _unref(LookupTableSource).Users,
                          "read-only": props.lockEditFields
                        }, null, 8, ["modelValue", "lookupSource", "read-only"]),
                        _createVNode(AcquaintInfoBox, {
                          label: "Follow Up Due Date",
                          text: formatedFollowUpDueDate.value
                        }, null, 8, ["text"]),
                        _createVNode(AcquaintInfoBox, {
                          label: "Last Updated",
                          text: formatedLastUpdatedDate.value
                        }, null, 8, ["text"]),
                        _createVNode(AcquaintInfoBox, {
                          label: "ID",
                          text: appointment.value.id.toString()
                        }, null, 8, ["text"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["selectedIndex"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          disabled: saving.value,
          options: {
          visible: !props.notificationAppointment,
          text: 'Save & Send Confirmations',
          onClick: (e) => {
            onSaveSendConfirmation(e);
          },
          validationGroup: 'edit-appointment-modal',
        }
        }, null, 8, ["disabled", "options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          disabled: saving.value,
          options: {
          text: 'Save',
          onClick: (e) => {
            onSaveClick(e);
          },
          validationGroup: 'edit-appointment-modal',
          visible: !props.notificationAppointment,
        }
        }, null, 8, ["disabled", "options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Snooze',
          onClick: (e) => {
            onSnoozeClick(e);
          },
          visible: props.notificationAppointment,
          validationGroup: 'edit-appointment-modal',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          disabled: saving.value,
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["disabled", "options"])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt", "loadingContent"]),
    _createVNode(FindPropertyModal, {
      modelValue: showFindPropertyModal.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((showFindPropertyModal).value = $event)),
      onPropertySelected: propertySelected
    }, null, 8, ["modelValue"]),
    _createVNode(FindContactModal, {
      modelValue: showFindContactModal.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((showFindContactModal).value = $event)),
      onContactSelected: contactSelected,
      onPrimaryContactSelected: onPrimaryContactSelected,
      "show-new-contact-button": true,
      onOpenNewContactModal: _cache[23] || (_cache[23] = ($event: any) => (displayNewContactModal.value = true))
    }, null, 8, ["modelValue"]),
    _createVNode(SelectUserModal, {
      modelValue: showSelectUserModal.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((showSelectUserModal).value = $event)),
      onSelectUser: userSelected
    }, null, 8, ["modelValue"]),
    _createVNode(EditFeedbackModal, {
      modelValue: displayEditFeebackModal.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((displayEditFeebackModal).value = $event)),
      propertyId: feedbackPropertyId.value,
      contactId: feedbackContactId.value,
      onModalClosed: feedbackModalClosed,
      onNavigateToContact: _cache[26] || (_cache[26] = ($event: any) => (unLockAppointment(props.appointmentId))),
      onNavigateToProperty: _cache[27] || (_cache[27] = ($event: any) => (unLockAppointment(props.appointmentId)))
    }, null, 8, ["modelValue", "propertyId", "contactId"]),
    _createVNode(ContactsPeekPopup, {
      modelValue: displayContactPeekModal.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((displayContactPeekModal).value = $event)),
      contactId: peekContactId.value,
      title: contactName.value
    }, null, 8, ["modelValue", "contactId", "title"]),
    _createVNode(PropertyPeekModal, {
      modelValue: displayPropertyPeekModal.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((displayPropertyPeekModal).value = $event)),
      "property-id": peekPropertyId.value,
      title: propertyPeekTitle.value
    }, null, 8, ["modelValue", "property-id", "title"]),
    (appointment.value)
      ? (_openBlock(), _createBlock(AppointmentConfirmationModal, {
          key: 0,
          modelValue: displayAppointmentConfirmationModal.value,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((displayAppointmentConfirmationModal).value = $event)),
          appointment: appointment.value,
          onModalClosed: onAppointmentConfirmationModalClosed
        }, null, 8, ["modelValue", "appointment"]))
      : _createCommentVNode("", true),
    _createVNode(ContactModal, {
      modelValue: displayNewContactModal.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((displayNewContactModal).value = $event)),
      onContactCreated: newContactCreated
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})